import {useEffect, useState} from 'react';

import useAxiosPrivate from './useAxiosPrivate';
import useRole from './useRole';

const useAdminRoleCompanyName = () => {

    const axiosPrivate = useAxiosPrivate();
    const [roleAdmin,setRoleAdmin]=useState('');
    const [companyName,setCompanyName]=useState('');
    const [signataire,setSignataire]=useState({});
    const role=useRole();

    const permissionToEdit = async () => {
        try {
            const response = await axiosPrivate.get(`${role}/getMyInfos`);
            if(role=='client'){
                setRoleAdmin(response?.data?.collaborator?.roles);
                setCompanyName(response?.data?.collaborator?.companyDataId?.profileEntreprise?.nom);
            }
            if(role=='esn'){
                setRoleAdmin(response?.data?.collaboratorEsn?.roles);
                setCompanyName(response?.data?.collaboratorEsn?.esnId?.profileEntreprise?.nom);
                setSignataire(response?.data?.collaboratorEsn?.esnId?.signataire);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if(role)
            permissionToEdit();
    }, [role]);

    return [roleAdmin,companyName,signataire];
};

export default useAdminRoleCompanyName;